import { useCallback, useEffect, useState } from 'react';
import {
  finalizeJourneyBrief,
  listJourneyFinalizedRevisions,
} from './journeyFinalizedRevisionService';

const useJourneyFinalizedRevisions = ({ childId, ownerUserId, draftIdentity }) => {
  const [revisions, setRevisions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [finalizing, setFinalizing] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setLoading(true);
    listJourneyFinalizedRevisions({ childId, draftId: draftIdentity?.draftId })
      .then((items) => { if (active) setRevisions(items); })
      .catch(() => { if (active) setError('Finished versions could not be loaded.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [childId, draftIdentity?.draftId]);

  const finalize = useCallback(async ({ brief, answers }) => {
    setFinalizing(true);
    setError('');
    try {
      const revision = await finalizeJourneyBrief({
        childId,
        ownerUserId,
        draftIdentity,
        brief,
        answers,
        previousRevisionId: revisions[0]?.revisionId || '',
      });
      setRevisions((current) => [revision, ...current]);
      return revision;
    } catch (finalizeError) {
      setError(finalizeError?.message || 'This brief could not be finished.');
      return null;
    } finally {
      setFinalizing(false);
    }
  }, [childId, draftIdentity, ownerUserId, revisions]);

  return { revisions, latestRevision: revisions[0] || null, loading, finalizing, error, finalize };
};

export default useJourneyFinalizedRevisions;
